import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../CustomTooltip";
import { useOrderMinimum } from "../../Constants/orderMinimum";

// Said wherever a supplier sets a price: the ORDER has a minimum, the item does
// not. A ₪25 job or a ₪12 chocolate bar is perfectly fine to sell — the member
// just can't check out with less than the minimum in their basket, after
// discounts and before delivery. Without this the first time a supplier meets
// the rule is a blocked order.

const chipStyle = {
  display: "inline-flex",
  alignItems: "center",
  marginTop: "6px",
  padding: "2px 8px",
  borderRadius: "12px",
  fontSize: "11px",
  fontWeight: 500,
  lineHeight: "16px",
  color: "rgba(62, 63, 76, 0.9)",
  backgroundColor: "rgba(255, 244, 229, 1)",
  cursor: "default",
};

const OrderMinimumHint = ({ sx }) => {
  const { t } = useTranslation("order-minimum");
  const orderMinimum = useOrderMinimum();

  if (!orderMinimum) return null;

  return (
    <CustomTooltip
      title={t("hint_tooltip", { amount: orderMinimum })}
      tooltipSxStyles={{ maxWidth: "280px", padding: "8px 10px" }}
    >
      <Box component="span" sx={{ ...chipStyle, ...sx }}>
        {t("hint_chip", { amount: orderMinimum })}
      </Box>
    </CustomTooltip>
  );
};

export default OrderMinimumHint;
